import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_NON_ENFORCEMENT_REASONS,
} from '../../../../actions/actionTypes';

const nonEnforcementReasons = fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_NON_ENFORCEMENT_REASONS
);

export default nonEnforcementReasons;

export const getAllIncidentsFiltersNonEnforcementReasons = state =>
  state.response?.data ?? [];

export const getAllIncidentsFiltersNonEnforcementReasonsGroupedByName = state => {
  const reasons = getAllIncidentsFiltersNonEnforcementReasons(state);
  const reasonsGroupedByName = reasons.reduce((groupedReasons, reason) => {
    const normalizedName = reason.name.trim();
    if (!groupedReasons[normalizedName]) {
      groupedReasons[normalizedName] = {
        name: normalizedName,
        reasons: [reason],
      };
    } else {
      groupedReasons[normalizedName].reasons.push(reason);
    }

    return groupedReasons;
  }, {});

  return reasonsGroupedByName;
};

export const getAllIncidentsFiltersNonEnforcementReasonNormalizedNamesFromCodes = (
  state,
  reasonCode
) => {
  if (!Array.isArray(reasonCode)) {
    return [];
  }

  const groupedReasons = getAllIncidentsFiltersNonEnforcementReasonsGroupedByName(
    state
  );
  const groupedReasonsValues = Object.values(groupedReasons);

  return reasonCode.reduce((normalizedNames, code) => {
    const foundValue = groupedReasonsValues.find(({ reasons }) =>
      reasons.some(reason => reason.code === code)
    );

    if (foundValue && !normalizedNames.includes(foundValue.name)) {
      normalizedNames.push(foundValue.name);
    }

    return normalizedNames;
  }, []);
};
